import { useIndexEventsGridData } from './use-index-events-grid-data';

import './IndexEventsGrid.scss';
import { IndexRebalanceEvent } from '../../api/IndexEventsResponse';
import { Grid, GridApi } from '@instinet-analytics/semantic-ui-components';
import { useWidgetGridState } from 'widgets/store/grid/useWidgetGridState';
import {
    getIndexEventWidgetColDefs,
    indexEventsWidgetGridColumnsDefinitionDictionary,
    IndexEventWidgetGridColumn,
} from './columns';
import { useContext, useMemo } from 'react';
import AppContext from 'app/AppContext';

const IndexEventsGrid = ({
    height,
    onGridApiSet,
    onRowSelected,
}: {
    height: number;
    onGridApiSet: (gridApi: GridApi) => void;
    onRowSelected: (row: IndexRebalanceEvent | undefined) => void;
}) => {
    const rowData = useIndexEventsGridData();

    const context = useContext(AppContext);

    const colDefs = useMemo(
        () => getIndexEventWidgetColDefs(context),
        [context]
    );

    const onGridReady = (api: GridApi) => {
        onGridApiSet(api);
    };

    const { gridPropsFromState, columnDefs } = useWidgetGridState<
        IndexRebalanceEvent,
        IndexEventWidgetGridColumn
    >(indexEventsWidgetGridColumnsDefinitionDictionary, colDefs);

    function onSelectedRowIdsChanged(rowDataIds: string[]) {
        const selectedRow =
            rowDataIds.length === 1
                ? rowData.find((r) => r.inet === rowDataIds[0])
                : undefined;
        onRowSelected(selectedRow);
    }

    return (
        <div className="IndexEventsGrid" style={{ height }}>
            <Grid
                className={
                    'historical-percentage-chart-widget-grid ag-theme-balham-dark'
                }
                columnDefs={columnDefs}
                rowData={rowData}
                getRowDataId={(d: IndexRebalanceEvent) => d.inet}
                suppressColumnVirtualisation={false}
                onGridReady={onGridReady}
                onSelectedRowIdsChanged={onSelectedRowIdsChanged}
                {...gridPropsFromState}
            />
        </div>
    );
};

export default IndexEventsGrid;
